module.exports = __webpack_public_path__ + "static/media/ill-start-by-opening-p4.ac267cc8.jpg";